
import checkLanguage from "./class_check_language";
export default class get_breadcrumbs {

    get_description() {
   
        let breadcrumbs = window.descrizione.descrizione;
        let l = new checkLanguage();
        if (l.is_italian()){
            return this.get_items_ita(breadcrumbs);
        }else{
            return this.get_items_en(breadcrumbs);
        }
    }
    get_tipologia() {
        let elements = window.descrizione.elements;
        let t = [];
        let l = new checkLanguage();
      try{
     elements.forEach(element => {
          if (l.is_italian()){
          element['LANG'] =  element['ITA'];
        }else{
            element['LANG'] =  element['ENG'];
          }
          t.push(element);
        });
      } catch (error) {
        console.info(error);
    }
        return t;
    }

    get_fita(breadcrumbs) {

        return  this.capitalize(breadcrumbs.fita.toLowerCase());

    }
    get_fen(breadcrumbs) {

        return  this.capitalize(breadcrumbs.fen.toLowerCase());

    }

    get_ten(breadcrumbs) {

      return  this.capitalize(breadcrumbs.ten.toLowerCase());
    }
    get_tita(breadcrumbs) {
        return  this.capitalize(breadcrumbs.tita.toLowerCase());
     }

    capitalize(s) {

        return s[0].toUpperCase() + s.slice(1);
      }

      get_items_ita(breadcrumbs) {
        let href = '';
        this.hostname = window.location.hostname;
        if (typeof breadcrumbs.fita == "string"){
          href =  "https://" + this.hostname + "/collezioni/"+breadcrumbs.fita.toLowerCase();
        }
        let hostname = window.location.hostname;
         let items = [
            {
              text: "Collezioni",
              disabled: false,
              href: "https://" + hostname + "/collezioni",
            },
            {
              text: this.get_fita(breadcrumbs),
              disabled: false,
              href: href,
            },
       //     {
       //       text: this.get_tita(breadcrumbs),
       //       disabled: true,
       //       href: "",
       //     },
          ];
        
        return items;
    
    }
    get_items_en(breadcrumbs) {
        let href = '';
        this.hostname = window.location.hostname;
        if (typeof breadcrumbs.fen == "string"){
          href =  "https://" + this.hostname + "/collezioni/"+breadcrumbs.fen.toLowerCase()+"/?lang=en";
        }
        let hostname = window.location.hostname;
         let items = [
            {
              text: "Collections",
              disabled: false,
              href: "https://" + hostname + "/collezioni/?lang=en",
            },
            {
              text: this.get_fen(breadcrumbs),
              disabled: false,
              href: href,
            },
        //    {
        //      text: this.get_ten(breadcrumbs),
        //      disabled: true,
        //      href: "",
        //    },
          ];
        
        return items;
    
    }

}
